import './Wizard.27153347796968a109698893b4435c15.css';
export default {"wizard":"_wizard_g0rfv_1","stepper":"_stepper_g0rfv_1","footer":"_footer_g0rfv_1"};